import React from 'react'
import Grid from "@material-ui/core/Grid";
import { useStyle } from './Style';

const RecentPoliciesHeader = (props) => {
  const classes = useStyle();
  return (
    <>
      <section className={classes.claimsheader}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.claimstitle}>
              <h1>{props.title}</h1>
              <div className={classes.subtitle}>
                <p>View policies created in the last 30 days, sorted by most recent first</p>
              </div>
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  )
}

export default RecentPoliciesHeader